<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="btnMenu" slot-scope="prop">
        <JurisdictionBox
          :disabled="$route.query.type === 'detail'"
          ref="btnMenu"
          v-model="prop.form.btnMenu"
        />
      </section>
      <section slot="dataMenu" slot-scope="prop">
        <JurisdictionBox
          :disabled="$route.query.type === 'detail'"
          ref="dataMenu"
          v-model="prop.form.dataMenu"
        />
      </section>
      <section slot="baseDataMenu" slot-scope="prop" style="display: flex">
        <el-popover placement="bottom" width="" trigger="hover">
          <div style="text-align: center">
            <span>档案数据包括档案管理内的全部数据</span>
          </div>
          <i class="el-icon-question warning" slot="reference"></i>
        </el-popover>
        <JurisdictionBox
            :disabled="$route.query.type === 'detail'"
            ref="baseDataMenu"
            v-model="prop.form.baseDataMenu"
        ></JurisdictionBox>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import JurisdictionBox from 'components/jurisdictionBox/jurisdictionBox.vue';
export default {
  components: {
    JurisdictionBox,
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '角色名称',
            value: 'roleName',
            type: 'input',
          },
          {
            label: '功能权限',
            value: 'btnMenu',
            default: [],
            slot: true,
          },
          {
            label: '数据权限（除档案数据）',
            value: 'dataMenu',
            default: [],
            slot: true,
          },
          {
            label: '档案数据权限',
            value: 'baseDataMenu',
            default: [],
            slot: true,
          },
        ],
        rules: {
          roleName: [ // 角色名称
            { required: true, message: '请输入角色名称', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData = {
          roleName: formData.roleName,
          entityIds: [
            ...this.$refs.btnMenu.getVal(),
            ...this.$refs.dataMenu.getVal(),
            ...this.$refs.baseDataMenu.getVal(),
          ].join(','),
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return {
        roleName: res.roleName,
        btnMenu: this.$refs.btnMenu.getFullVal(),
        dataMenu: this.$refs.dataMenu.getFullVal(),
        baseDataMenu: this.$refs.baseDataMenu.getFullVal(),
      };
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'type',
        value: this.$route.query.type ? 'show' : 'input',
        names: ['roleName'],
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
